import React, { useState } from "react";
import BaseModal from "../BaseModal";
import PatientName from "../Common/PatientName";
import TextArea from "../Common/TextArea";
import Button from "../../Buttons/Button";
// import DatePicker from "react-datepicker";
// import "react-datepicker/dist/react-datepicker.css";
// import "react-datepicker/dist/react-datepicker-cssmodules.css";
import "./style.css";
// import CustomDatePicker from "../../CustomDatePicker";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";
// import CustomCalendarIcon from './CustomCalendarIcon'; // Import your custom icon component
import UnfoldMoreIcon from "@mui/icons-material/UnfoldMore";

/**
 * Reusable Modal for visit management modal popups like initiate new visit, add and edit visit records
 * @param {function} onClose - Function to handle the modal close event
 * @param {object} patientInfo - Information about the patient
 */

const VisitModal = ({ type, onClose, patientInfo }) => {
  const modalTitleMap = {
    initiate: "Initiate New Visit",
    add: "Add New Record",
    edit: "Edit Record",
  };
  const flyerMessageMap = {
    initiate: "Visit has been created successfully!",
    add: "Record has been added successfully!",
    edit: "Record has been saved successfully!",
  };

  // State to manage the visit date & notes
  const [visitDate, setVisitDate] = useState(new Date());
  const [notes, setNotes] = useState("");
  const [isCalendarOpen, setIsCalendarOpen] = useState(false); // Track the calendar open state
  const [isRecordUpdated, setIsRecordUpdated] = useState(false);

  const handleNotesChange = (event) => {
    setNotes(event.target.value);
  };

  const handleRecordAudio = (event) => {};

  const handleFile = (event) => {};

  const handleCalendarClose = () => {
    setIsCalendarOpen(false);
  };
  const handleCalendarOpen = () => {
    setIsCalendarOpen(true);
  };

  const handleButtonClick = async (event) => {
    // API call or any asynchronous action
    await new Promise((resolve) => setTimeout(resolve, 1000));

    setIsRecordUpdated(true); // Set the state to show FlyerMessage with the messageType
  };

  // Event handler for when the user clicks the "Close" button on FlyerMessage
  const handleFlyerMessageClose = () => {
    onClose();
    // Reset the state to hide FlyerMessage
    setIsRecordUpdated(false);
  };

  return (
    //Reusable components - BaseModal, PatientName, TextArea, Button for add file, record audio and send  - pass props accordingly

    <BaseModal
      title={modalTitleMap[type]}
      onClose={onClose}
      showFlyerMessage={isRecordUpdated}
      flyerMessageText={flyerMessageMap[type]}
      onFlyerMessageClose={handleFlyerMessageClose}
    >
      <div className="modal-patient-info-frame ">
        <PatientName {...patientInfo} />

        <LocalizationProvider dateAdapter={AdapterDayjs}>
          <DatePicker
            sx={{ width: "178px" }}
            format="DD/MM/YYYY"
            slots={{ openPickerIcon: UnfoldMoreIcon }}
          />
        </LocalizationProvider>
        {/*<DatePicker
          selected={visitDate}
          onChange={(date) => setVisitDate(date)}
          dateFormat="dd MMM yyyy"
          customInput={<CustomDatePicker />}
          onCalendarClose={handleCalendarClose}
          onCalendarOpen={handleCalendarOpen}
        /> */}
      </div>

      <TextArea
        textAreaType="notes"
        placeholder="Add notes for the patient here....!"
        value={notes}
        onChange={handleNotesChange}
      />

      <div className="modal-button-group">
        <Button btnType="file" onClick={handleFile} />
        <Button btnType="audio" onClick={handleRecordAudio} />
      </div>

      <Button
        btnType={type === "initiate" ? "send" : "save"}
        onClick={handleButtonClick}
      />
    </BaseModal>
  );
};

export default VisitModal;
